import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  isShiftOpen: false
}

export default new Vuex.Store({
  state
})



// WEBPACK FOOTER //
// ./src/store/store.js